// extracted by mini-css-extract-plugin
export default {"cikTable":"ClicksByKeywords_cikTable__6WUCy"};